// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteBreedsController from "./autocomplete_breeds_controller"
application.register("autocomplete-breeds", AutocompleteBreedsController)

import ClearFormController from "./clear_form_controller"
application.register("clear-form", ClearFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PasswordStrengthMeterController from "./password_strength_meter_controller"
application.register("password-strength-meter", PasswordStrengthMeterController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import StripePaymentController from "./stripe_payment_controller"
application.register("stripe-payment", StripePaymentController)

import PreventBackController from "./prevent_back_controller"
application.register("prevent-back", PreventBackController)

import ToggleRemitToController from "./toggle_remit_to_controller"
application.register("toggle-remit-to", ToggleRemitToController)
